export const EXCEL_SETTINGS = [
    {name: "№", code: "ID",order: 1,fixed: true},
    {name: "Мол-мулк номи", code: "NAME",order: 2,fixed: false},
    {name: "Вилоят", code: "PROVINCE",order: 3, fixed: true},
    {name: "Балансга кабул килинган сана", code: "BALANCE_DATE",order: 4, fixed: false},
    {name: "Мол-мулк сони", code: "NUMBER_OF_PROPERTY",order: 5, fixed: false},
    {name: "Асосий фондларнинг коди", code: "STOCK_CODE",order: 6, fixed: false},
    {name: "Асосий восита раками", code: "PROPERTY_NUMBER",order: 7, fixed: false},
    {name: "Дастлабки тикланиш киймати", code: "REC_AMOUNT",order: 8, fixed: false},
    {name: "Эскириш", code: "DEP_AMOUNT",order: 9, fixed: false},
    {name: "Қолдиқ қиймат", code: "RES_AMOUNT",order: 10, fixed: false}
]